export {
  useWidgetClockContext,
  WidgetClockProvider,
} from './context-clock';
